export default {
    Login: "/api/UserManger/Login",//登录
    Dev_Login: "api/UserManger/Dev_Login",
    SNSMsgList:"/api/Service/SNSMsgList",
    RegisterOrgUser:"/api/UserManger/RegisterOrgUser",
    GetAllEnterprise: "/api/UserManger/GetAllEnterprise",//获取企业列表
    GetEnterpriseById: "/api/UserManger/GetEnterpriseById",//企业详情
    UserPhoneBook: "/api/UserManger/UserPhoneBook",//用户通讯录
    AddUserOrg:"/api/UserManger/AddUserOrg",
    GetUserById: "/api/UserManger/GetUserById",//根据ID得到用户，
    UpdateEnterprise: "/api/UserManger/UpdateEnterprise",
    UpdateUserInfo: "/api/UserManger/UpdateUserInfo", //更新用户信息
    GetNoticeList: "/api/UserManger/GetNoticeList",
    AddNotice: "/api/UserManger/AddNotice",
    GetNoticeId: "/api/UserManger/GetNoticeId",
    GetOrgRoleList: "/api/UserManger/GetOrgRoleList",
    UploadpublishFile: "/api/Service/UploadpublishFile",
    Publishziplist:"/api/Service/Publishziplist",
    SetTokenExpire:"/api/Service/SetTokenExpire",
    MoNiRequest:"api/Service/MoNiRequest",
    
    UserFeedback: "/api/UserManger/UserFeedback",
    UpdateFeedback:"/api/UserManger/UpdateFeedback",
    GetGroupNameList:"/api/Service/GetGroupNameList",
    UserRoleAllMenu: "/api/Service/UserRoleAllMenu",
    GetMenuInfo: "/api/Service/GetMenuInfo",
    UpdateMenu: "/api/Service/UpdateMenu",
    AddMenu: "/api/Service/AddMenu",
    AddHelpMenu: "/api/Service/AddHelpMenu",
    HelpAllMenu: "/api/Service/HelpAllMenu",
    AddHelpInfo: "/api/Service/AddHelpInfo",
    GetHelpInfoList: "/api/Service/GetHelpInfoList",
    GetHelpMenuInfo: "/api/Service/GetHelpMenuInfo",
    UpdateHelpMenuInfo: "/api/Service/UpdateHelpMenuInfo",
    UpdateHelpMenu: "/api/Service/UpdateHelpMenu",
    DelHelpMenuInfo: "/api/Service/DelHelpMenuInfo",
    GetSystemVersionList: "/api/Service/GetSystemVersionList",
    AddSystemVersion: "/api/Service/AddSystemVersion",
    GetSystemVersionId: "/api/Service/GetSystemVersionId",
    UpdateSystemVersion:"/api/Service/UpdateSystemVersion"
}